import { toast } from "react-toastify";

// Muitos pontos do app chamam toast.success/error/info/warn diretamente,
// sem toastId. Sem toastId estável, o dedup nativo do react-toastify não
// entra em ação: se o mesmo toast for disparado mais de uma vez em rajada
// (duplo clique, handler de socket registrado 2x, efeito rodando de novo),
// cada chamada cria um toast com ID diferente e eles piscam empilhados.
// Este patch injeta um toastId estável (baseado no texto da mensagem) em
// qualquer chamada que não tenha informado um, para todo o app de uma vez.
const methods = ["success", "error", "info", "warn", "warning"];

methods.forEach((method) => {
  const original = toast[method].bind(toast);

  toast[method] = (content, options = {}) => {
    if (options.toastId || typeof content !== "string") {
      return original(content, options);
    }

    return original(content, { ...options, toastId: `${method}-${content}` });
  };
});
